export default __webpack_public_path__ + "static/media/pic2.22a0952d.jpg";